import {IState} from "@/interfaces/IState";
import {IPdf} from "@/interfaces/pdf/IPdf";

export const pdf = {
    state: {
        zoom: 100,
        openSurveys: false,
        loadedPdf: false
    },
    mutations: {
        PDF_ZOOM(state: IState, payload: IPdf){
            state.zoom = payload.zoom;
        },
        OPEN_SURVEYS(state: IState, payload: IPdf) {
            state.openSurveys = payload.openSurveys;
        },
        LOADED_PDF(state: IState, payload: IPdf) {
            state.loadedPdf = payload.loadedPdf;
        }
    },
    actions: {
        setZoom(context: any, payload: IPdf) {
            context.commit("PDF_ZOOM", payload);
        },
        setOpenSurveys(context: any, payload: IPdf) {
            context.commit("OPEN_SURVEYS", payload);
        },
        setLoadedPdf(context: any, payload: IPdf) {
            context.commit("LOADED_PDF", payload);
        }
    },
    getters: {
        getZoom(state: IState) {
            return state.zoom;
        },
        getOpenSurveys(state: IState) {
            return state.openSurveys;
        },
        getLoadedPdf(state: IState) {
            return state.loadedPdf;
        }
    }
}